import React from 'react';
import { CalendarDaysIcon, ClockIcon, InfoIcon, MapPinIcon } from 'lucide-react';
import { NewTabHint } from '../ui/NewTabHint';
import type { BcmEvent } from '../../data/events';
const categoryStyles: Record<BcmEvent['category'], string> = {
  'Fall 2026': 'bg-brand-yellow text-[#3d2b00]',
  Weekly: 'bg-brand-blue text-brand-navy',
  'Coming Soon': 'bg-brand-pink text-[#3f1730]'
};
export function EventCard({
  event
}: {
  event: BcmEvent;
}) {
  return <article className="flex h-full flex-col rounded-[20px] border-2 border-brand-navy bg-white p-6" data-id="element-80" data-mp="1ieb23r0hzv87">
      <span className={`inline-flex w-fit items-center rounded-full px-3 py-1 font-meta text-[11px] font-semibold uppercase tracking-[0.14em] ${categoryStyles[event.category]}`} data-id="element-81" data-mp="1djonzg317okf">
        {event.category}
      </span>

      <h3 className="mt-4 font-display text-2xl font-bold leading-tight text-brand-navy" data-id="element-82" data-mp="zkp0wcv63hqd">
        {event.title}
      </h3>

      <dl className="mt-4 space-y-2 font-meta text-[13px] text-ink" data-id="element-83" data-mp="un5jj436aou7">
        <div className="flex items-start gap-2" data-id="element-84" data-mp="1crni1xevx51m">
          <dt className="sr-only" data-id="element-85" data-mp="1cqvkwi5n2z98">Date</dt>
          <CalendarDaysIcon aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 text-brand-navy" data-id="element-86" data-mp="1hjoov3taa3k9" />
          <dd data-id="element-87" data-mp="13stf7paynifm">{event.date}</dd>
        </div>
        {event.time ? <div className="flex items-start gap-2" data-id="element-88" data-mp="18r4q83czryzf">
            <dt className="sr-only" data-id="element-89" data-mp="18rmrxfifb5eq">Time</dt>
            <ClockIcon aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 text-brand-navy" data-id="element-90" data-mp="1wgphran7o4kb" />
            <dd data-id="element-91" data-mp="20iaqcjsppwop">{event.time}</dd>
          </div> : null}
        {event.location ? <div className="flex items-start gap-2" data-id="element-92" data-mp="20fy9yb2lrudr">
            <dt className="sr-only" data-id="element-93" data-mp="1mhq7jnmss0v7">Location</dt>
            <MapPinIcon aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 text-brand-navy" data-id="element-94" data-mp="1rhmdvtiyw4dx" />
            <dd data-id="element-95" data-mp="b3cocw2zo9li">{event.location}</dd>
          </div> : null}
        {event.locationNote ? <div className="flex items-start gap-2" data-id="element-96" data-mp="g2ftshmvshu0">
            <dt className="sr-only" data-id="element-97" data-mp="g38scvbos112">Details</dt>
            <InfoIcon aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 text-brand-navy" data-id="element-98" data-mp="3s5pjtze0o7zy" />
            <dd data-id="element-99" data-mp="3o441hyipr1id">{event.locationNote}</dd>
          </div> : null}
      </dl>

      <p className="mt-4 font-sans text-[15px] leading-relaxed text-ink" data-id="element-100" data-mp="3o68dz4uoh8u9">{event.description}</p>

      {event.clarification ? <p className="mt-3 font-meta text-[12.5px] leading-relaxed text-ink" data-id="element-101" data-mp="3eekf4ivskpir">
          {event.clarification}
        </p> : null}

      {event.cta || event.reference ? <div className="mt-5 flex flex-wrap items-center gap-x-4 gap-y-3 pt-1" data-id="element-102" data-mp="39cv6f9w1knxu">
          {event.cta ? <a href={event.cta.href} target="_blank" rel="noopener noreferrer" className="inline-flex min-h-[44px] items-center rounded-full border-2 border-brand-navy bg-brand-navy px-5 font-display text-sm font-semibold text-white transition-colors hover:bg-[#083a7c]" data-id="element-103" data-mp="30eji5eine28k">
              {event.cta.label}
              <NewTabHint data-id="element-104" data-mp="tm0jcobaa11e" />
            </a> : null}
          {event.reference ? <a href={event.reference.href} target="_blank" rel="noopener noreferrer" className="font-meta text-[13px] font-semibold text-brand-navy underline underline-offset-4 hover:no-underline" data-id="element-105" data-mp="117chyzd4bou4">
              {event.reference.label}
              <NewTabHint data-id="element-106" data-mp="1fyld1nzsi2en" />
            </a> : null}
        </div> : null}
    </article>;
}